import { exhaustiveTuple } from 'src/replicant/utils/types';
import { WebPaymentMethod } from './iap.types';

/**
 * Order of payment methods in the UI (AB test)
 * ordered according to unique usage - https://app.amplitude.com/analytics/playco/chart/nmw9355s
 */
export const orderV2Android = exhaustiveTuple<WebPaymentMethod>()(
  'komoju_paypay',
  'komoju_docomo',
  'komoju_aupay',
  'komoju_credit_card',
  'komoju_softbank',
  'stripe_googlePay',
  'komoju_au',
  'komoju_rakutenpay',
  'atone_lite',
  'atone_bnpl',
  'komoju_merpay',

  'stripe_applePay', // Disabled
  'komoju_paidy', // Disabled
);

export const orderV2iOS = exhaustiveTuple<WebPaymentMethod>()(
  'komoju_paypay',
  'komoju_aupay',
  'komoju_docomo',
  'stripe_applePay',
  'komoju_credit_card',

  'komoju_rakutenpay',
  'komoju_softbank',
  'komoju_au',
  'atone_bnpl',
  'atone_lite',
  'komoju_merpay',

  'stripe_googlePay', // Disabled
  'komoju_paidy', // Disabled
);
